import { styled } from '@/styled-system/jsx';
import { css } from '@/styled-system/css';

export const PhotoCarouselV2 = styled('div', {
  base: {
    height: '100%',
  },
});

export const PhotoCarouselV2Container = styled('div', {
  base: {
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    borderRadius: '1x',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#d8d8d8',
    WebkitOverflowScrolling: 'touch',
    // Create isolation context to prevent layout issues
    isolation: 'isolate',
    // Improve containment for performance
    contain: 'layout style paint',
  },
});

// Track styles
export const photoCarouselV2Track = css({
  overflow: 'hidden',
  height: '100%',
  display: 'flex',
  transitionProperty: 'transform',
  transitionDuration: '0.05s',
  transitionTimingFunction: 'ease-out',
  // Optimize for transform animations
  willChange: 'transform',
  // Ensure proper containment to prevent layout issues
  contain: 'layout style',
  lg: {
    transition: 'none',
  },
});

export const photoCarouselV2TrackTransition = css({
  transitionProperty: 'transform',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'ease-out',
});

export const PhotoCarouselV2ItemWrapper = styled('li', {
  base: {
    overflow: 'hidden',
    height: '100%',
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
    textAlign: 'center',
    verticalAlign: 'middle',
    position: 'relative',
    // no-user-select mixin equivalent
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
  },
});

export const photoCarouselV2Item = css({
  overflow: 'hidden',
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // no-user-select and user-drag prevention
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
});

export const photoCarouselV2ItemImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
  display: 'block',
});

export const photoCarouselV2ItemImageContain = css({
  width: '100%',
  height: '100%',
  objectFit: 'contain', // Show complete image without cropping
  objectPosition: 'center center',
  display: 'block',
});

export const photoCarouselV2ItemHidden = css({
  visibility: 'hidden',
});

// Navigation target areas
export const PhotoCarouselV2PrevTarget = styled('div', {
  base: {
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    width: '25%',
    textAlign: 'left',
    cursor: 'pointer',
    pointerEvents: 'auto',
    // no-user-select mixin equivalent
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
  },
});

export const PhotoCarouselV2NextTarget = styled('div', {
  base: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    width: '25%',
    textAlign: 'right',
    cursor: 'pointer',
    pointerEvents: 'auto',
    // no-user-select mixin equivalent
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
  },
});

// Arrow controls
export const PhotoCarouselV2ArrowControls = styled('div', {
  base: {},
});

export const photoCarouselV2Arrow = css({
  fontSize: 'md',
  marginTop: '0px',
  marginRight: '16px',
  marginBottom: '0px',
  marginLeft: '16px',
  position: 'absolute',
  padding: '8px',
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  visibility: 'visible',
  backgroundColor: 'hpxWhite',
  borderRadius: '50%',
  height: '4x',
  width: '4x',
  filter: 'drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.7))',
  cursor: 'pointer',
  border: 'none',
  // no-user-select mixin equivalent
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
});

export const photoCarouselV2ArrowRight = css({
  right: '0',
});

export const photoCarouselV2ArrowDisabled = css({
  color: 'hpxGrey600',
});

// Item count display
export const photoCarouselV2ItemCount = css({
  position: 'absolute',
  color: 'hpxWhite',
  fontWeight: 'normal',
  backgroundColor: 'hpGrayTranslucent',
  padding: '1x',
  fontSize: 'sm',
  textShadow: '1px 1px 1px rgba(0, 0, 0, 0.5)',
  // no-user-select mixin equivalent
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
});

export const photoCarouselV2ItemCountBottomRight = css({
  bottom: '2x',
  right: '2x',
});

export const photoCarouselV2ItemCountTopRight = css({
  borderRadius: 'xs',
  top: '1x',
  right: '2x',
  xxl: {
    top: '2x',
  },
});

export const PhotoCarouselV2ItemCountBadge = styled('div', {
  base: {
    lineHeight: '10px',
  },
});

export const photoCarouselV2ItemCountHide = css({
  display: 'none !important',
});
